import * as Constants from '../constants/media';

export const getPetMedia = ($http, ENV, petId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_PET_MEDIA_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/1.0/pets/${petId}/media/`,
    })
      .then((res) => {
        dispatch({ type: Constants.GET_PET_MEDIA_SUCCESS, payload: res.data.media });
        resolve(res.data.media);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_PET_MEDIA_FAILED, payload: error });
        reject(error);
      });
  });

export const getMediaInfo = ($http, ENV, mediaId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_MEDIA_INFO_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/1.0/media/files/${mediaId}/`,
    })
      .then((res) => {
        dispatch({ type: Constants.GET_MEDIA_INFO_SUCCESS, payload: res.data.files });
        resolve(res.data.files);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_MEDIA_INFO_FAILED, payload: error });
        reject(error);
      });
  });

export const setMediaInfo = ($http, ENV, mediaId, settings) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.SET_MEDIA_INFO_REQUEST });

    $http({
      method: 'PUT',
      url: ENV.apiEndpoint + `/1.0/media/files/${mediaId}/`,
      data: settings,
    })
      .then((res) => {
        dispatch({ type: Constants.SET_MEDIA_INFO_SUCCESS, payload: res.data.files });
        resolve(res.data.files);
      })
      .catch((error) => {
        dispatch({ type: Constants.SET_MEDIA_INFO_FAILED, payload: error });
        reject(error);
      });
  });

export const getMediaURL = ($http, ENV, mediaId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_MEDIA_URL_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/1.0/media/files/${mediaId}/token/`,
    })
      .then((res) => {
        dispatch({ type: Constants.GET_MEDIA_URL_SUCCESS, payload: res.data.file });
        resolve(res.data.file);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_MEDIA_URL_FAILED, payload: error });
        reject(error);
      });
  });

export const deleteMedia = ($http, ENV, mediaId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.DELETE_PET_MEDIA_REQUEST });

    $http({
      method: 'DELETE',
      url: ENV.apiEndpoint + `/1.0/media/files/${mediaId}/`,
    })
      .then((res) => {
        dispatch({ type: Constants.DELETE_PET_MEDIA_SUCCESS, payload: 'success' });
        resolve(res);
      })
      .catch((error) => {
        dispatch({ type: Constants.DELETE_PET_MEDIA_FAILED, payload: error });
        reject(error);
      });
  });

export const setActiveMedia = (media) => ({
  type: Constants.SET_ACTIVE_MEDIA,
  payload: media,
});
